<template>
    <v-select :options="paginated" @search="query => search = query" :filterable="false">
      <li slot="list-footer" class="pagination">
        <button @click="offset -= 2" :disabled="!hasPrevPage">Prev</button>
        <button @click="offset += 2" :disabled="!hasNextPage">Next</button>
      </li>
      <span slot="no-options">{{ $t('patients.no_search_data') }}</span>
    </v-select>
</template>
<script>
    export default {
        name: 'buttonSelectBox',
        props: [ 'item' ],

        data() {
            return {
              countries: ['Afghanistan', 'Albania', 'Algeria'],
              search: '',
              offset: 0,
              limit: 2,
            }
        },
      computed: {
        filtered () {
          return this.countries.filter(value => value.includes(this.search));
        },
        paginated () {
          return this.filtered.slice(this.offset, this.limit + this.offset);
        },
        hasNextPage () {
          const nextOffset = this.offset + 2;
          return Boolean(this.filtered.slice(nextOffset, this.limit + nextOffset).length);
        },
        hasPrevPage () {
          const prevOffset = this.offset - 2;
          return Boolean(this.filtered.slice(prevOffset, this.limit + prevOffset).length);
        }
      },
    }
</script>
<style>
  .pagination {
    display: flex;
    margin: .25rem .25rem 0;
  }
  .pagination button {
    flex-grow: 1;
  }
  .pagination button:hover {
    cursor: pointer;
  }
</style>